
@if (!isNotFound) {
  <div class="my-card my-card--no-margin">
    <mibp-loader></mibp-loader>
  </div>
}



@if (isNotFound) {
  <div class="my-card my-card--no-margin">
    <div id="content content-primary">
      <h1 class="heading-type-3">404<span><mibp-resource-string key="Error_PageNotFound"></mibp-resource-string></span></h1>
      <div class="article text">
        <div class="article-inner">
          <div class="article-inner-inner">
            <p><mibp-resource-string key="Error_PageNotFoundText"></mibp-resource-string></p>
          </div>
        </div>
      </div>
    </div>
  </div>
}

